import React, { Component } from 'react';
import config from '../config';
const fileService = config.FILE_ADDRESS;

class CoverImage extends Component {
  constructor(props) {
    super(props);
    this.coverImageRef = React.createRef();
  }

  componentDidMount() {
    const canvas = this.coverImageRef.current;
    const id = this.props.coverImage.uploaded.id;
    const ctx = canvas.getContext('2d');
    const image = new Image();
    image.src = `${fileService}/${id}`;
    image.className = 'ReactCrop__image';
    image.alt = '';
    const img = image;
    img.onload = () => {
      ctx.drawImage(
        img,
        -this.props.coverImage.crop.naturalX,
        -this.props.coverImage.crop.naturalY
      );
    };
  }

  render() {
    return (
      <canvas
        ref={this.coverImageRef}
        width={this.props.coverImage.crop.naturalWidth}
        height={this.props.coverImage.crop.naturalHeight}
        style={{
          width: '100%',
          height: 'auto',
          minHeight: '200px',
          objectFit: 'cover',
          maxHeight: '350px',
        }}
      />
    );
  }
}

export default CoverImage;
